export const Address = () => {
  return (
    <div>
      <h1 className="text-capitalize text-size-h1">SimplePay Demo Station</h1>
      <h1 className="text-capitalize">Am Messesee 2, 81829 München</h1>
    </div>
  );
};
